import { useState } from 'react'

import { COLOR_FORMAT_HEX } from '../../../ColorPicker.constants'
import { useRisingEdgeEffect } from '../../../ColorPicker.hooks'
import {
  getDisplayColorValue,
  normalizeHexColor,
} from '../../ColorPickerField.utils'

export function useColorPickerFieldDraft({ committedColor, format, isOpen }) {
  const [draftFormat, setDraftFormat] = useState(COLOR_FORMAT_HEX)
  const [draftPopoverColor, setDraftPopoverColor] = useState(committedColor)
  const [draftValueState, setDraftValueState] = useState({
    color: committedColor,
    format: COLOR_FORMAT_HEX,
    value: getDisplayColorValue(committedColor, COLOR_FORMAT_HEX),
  })

  function handlePopoverOpen() {
    setDraftFormat(format)
  }

  useRisingEdgeEffect({ value: isOpen, onRisingEdge: handlePopoverOpen })

  const [prevSync, setPrevSync] = useState(null)

  // While the popover is closed, keep the draft in sync with the committed
  // color/format — during render (the documented alternative to an effect).
  // The `null` sentinel runs this on mount too, matching the original effect.
  if (
    prevSync === null ||
    prevSync.committedColor !== committedColor ||
    prevSync.format !== format ||
    prevSync.isOpen !== isOpen
  ) {
    setPrevSync({ committedColor, format, isOpen })

    if (!isOpen) {
      setDraftPopoverColor(committedColor)
      setDraftFormat(format)
      setDraftValueState({
        color: committedColor,
        format,
        value: getDisplayColorValue(committedColor, format),
      })
    }
  }

  function setDraftColor(nextColor) {
    const normalizedColor = normalizeHexColor(nextColor)

    setDraftPopoverColor(normalizedColor)
    setDraftValueState({
      color: normalizedColor,
      format: draftFormat,
      value: getDisplayColorValue(normalizedColor, draftFormat),
    })
  }

  return {
    draftFormat,
    draftPopoverColor,
    draftValueState,
    setDraftColor,
    setDraftFormat,
    setDraftPopoverColor,
    setDraftValueState,
  }
}
